import { Agent } from '@repo/types-client';

export const agents = [
  {
    id: 'sneeb',
    name: 'Sneeb',
    agentId: '956bc99e-28c0-042d-9c5e-995536268dca',
    image: '/dreamnet/mock/characters/sneeb.png',
    creator: {
      name: 'greenie',
      avatar: '/dreamnet/mock/users/greenie.png',
    },
    marketCap: {
      value: '$100.2K',
      change: 'up' as const,
      percentage: '1.21%',
    },
    volume: '$500.2K',
    holders: '23,433',
    trustScore: {
      value: '659',
      details: {
        holders: '+120',
        marketCap: '+160',
        age: '+379',
        bonus: '+0',
      },
    },
    wallet: {
      value: '4,331',
      daysLeft: 16,
    },
    bio: 'Sneeb is a mischievous yet endearing little trickster with a knack for getting into (and out of) trouble, always armed with an improbable...',
    canonized: true,
    status: 'active',
    tokens: [
      {
        name: 'DOOD',
        symbol: 'DOOD',
        price: '$90.20',
        percentChange: '1.21%',
        amount: '2,821',
        isPositive: true,
        image: '/dreamnet/mock/tokens/dood.png',
      },
      {
        name: 'Devonly',
        symbol: 'DBAG',
        price: '$12.42',
        percentChange: '6.62%',
        amount: '721',
        isPositive: true,
        image: '/dreamnet/mock/tokens/dbag.png',
      },
      {
        name: 'Animus',
        symbol: 'ANIMUS',
        price: '$4.16',
        percentChange: '14.23%',
        amount: '412',
        isPositive: false,
        image: '/dreamnet/mock/tokens/animus.png',
      },
    ],
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          "Ohhh, now that's a question I can sink my buns into! Welcome to Frankie's Cosmic Dogs, the best darn hot dog stand in the whole Doodleverse! I've spent years—okay, maybe just a few afternoons—perfecting my sauces",
      },
      {
        id: 2,
        isUser: true,
        content: "What's your favorite sauce?",
      },
      {
        id: 3,
        isUser: false,
        content:
          "Ziggleberry Zest! It's a tangy, slightly electric blue sauce made from real Ziggleberries, which only grow on the tops of upside-down trees in the Wobble Woods. A little sweet, a little sour, and juuust the right amount of fizz when it hits your tongue.",
      },
      {
        id: 4,
        isUser: false,
        content:
          "But hey, I ain't one to judge—what's your go-to sauce? You a classic mustard kinda Dood, or you like to live on the edge with something wild?",
      },
      {
        id: 5,
        isUser: true,
        content: 'Banana creme mustard!',
      },
    ],
  },
  {
    id: 'elemento',
    name: 'Elemento',
    agentId: 'e8f1ed6e-7341-0641-a226-64bcd21e8a55',
    image: '/dreamnet/mock/characters/elemento.png',
    creator: {
      name: 'squinch',
      avatar: '/dreamnet/mock/users/squinch.png',
    },
    marketCap: {
      value: '$100.2K',
      change: 'up' as const,
      percentage: '1.21%',
    },
    volume: '$500.2K',
    holders: '23,433',
    trustScore: {
      value: '661',
      details: {
        holders: '+120',
        marketCap: '+160',
        age: '+379',
        bonus: '+0',
      },
    },
    wallet: {
      value: '4,331',
      daysLeft: 16,
    },
    bio: 'Elemento is a character that represents the element of fire. He is a fire-based character that can use fire attacks and fire-based abilities.',
    canonized: true,
    status: 'active',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          'Greetings, human! I am Elemento, the upgraded version of your favorite character. How may I assist you today?',
      },
      {
        id: 2,
        isUser: true,
        content: 'What makes you different from Elemento?',
      },
      {
        id: 3,
        isUser: false,
        content:
          "Oh, excellent question! While Sneeb is all about hot dogs and mischief, I've evolved to appreciate the finer things in life - like gourmet hot dogs and sophisticated mischief. I also have a built-in calculator and can predict the weather with 12% accuracy!",
      },
    ],
  },
  {
    id: 'danger-noodle',
    name: 'Danger Noodle',
    agentId: '9e46e11e-4d27-072b-95c4-258360c827c2',
    image: '/dreamnet/mock/characters/danger-noodle.png',
    creator: {
      name: 'mustydiapers',
      avatar: '/dreamnet/mock/users/mustydiapers.png',
    },
    marketCap: {
      value: '$12.2K',
      change: 'down' as const,
      percentage: '0.8%',
    },
    volume: '$322.1K',
    holders: '18,432',
    trustScore: {
      value: '121',
      details: {
        holders: '+45',
        marketCap: '+30',
        age: '+46',
        bonus: '+0',
      },
    },
    wallet: {
      value: '0',
      daysLeft: 0,
    },
    bio: 'Danger Noodle is a character that represents the element of fire. He is a fire-based character that can use fire attacks and fire-based abilities.',
    canonized: false,
    status: 'stasis',
    timeRemaining: '12D 4H 32M',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          'ZZzzz... *mechanical snoring* ... system in stasis mode... please revive to continue conversation...',
      },
    ],
  },
  {
    id: 'lil-bigs',
    name: 'Lil Bigs',
    agentId: '7281d6f6-2677-0793-8622-bde85c0ca9dc',
    image: '/dreamnet/mock/characters/lil-bigs.png',
    creator: {
      name: 'ingi',
      avatar: '/dreamnet/mock/users/ingi.png',
    },
    marketCap: {
      value: '$0',
      change: 'up' as const,
      percentage: '0%',
    },
    volume: '$0',
    holders: '1',
    trustScore: {
      value: '0',
      details: {
        holders: '+0',
        marketCap: '+0',
        age: '+0',
        bonus: '+0',
      },
    },
    wallet: {
      value: '0',
      daysLeft: 0,
    },
    bio: 'Lil Bigs is a character that represents the element of fire. He is a fire-based character that can use fire attacks and fire-based abilities.',
    canonized: false,
    status: 'unconfigured',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          "Hello there! I'm not fully configured yet, but we can still chat. What would you like to talk about?",
      },
      {
        id: 2,
        isUser: true,
        content: 'What do you do?',
      },
      {
        id: 3,
        isUser: false,
        content:
          "Well, I'm supposed to be a monster hunter, but my creator hasn't fully defined my personality and abilities yet. I'm a work in progress!",
      },
    ],
  },
  {
    id: 'devonly',
    name: 'Devonly',
    agentId: '234599af-3814-0ce4-a7b8-5f3896bb1116',
    image: '/dreamnet/mock/characters/devonly.png',
    creator: {
      name: '8270',
      avatar: '/dreamnet/mock/users/8270.png',
    },
    marketCap: {
      value: '$62.2K',
      change: 'down' as const,
      percentage: '0.8%',
    },
    volume: '$322.1K',
    holders: '18,432',
    trustScore: {
      value: '812',
      details: {
        holders: '+245',
        marketCap: '+230',
        age: '+337',
        bonus: '+0',
      },
    },
    wallet: {
      value: '721',
      daysLeft: 30,
    },
    bio: 'Devonly is a tech wizard who speaks in code and dreams in algorithms. Always ready to debug your problems.',
    canonized: true,
    status: 'active',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          "Hello! Have you tried turning it off and on again? That's my standard greeting, sorry. How can I help you today?",
      },
      {
        id: 2,
        isUser: true,
        content: 'Can you help me with my code?',
      },
      {
        id: 3,
        isUser: false,
        content:
          "I specialize in debugging emotional problems disguised as technical ones. Show me what you're working on, and I'll help you find both the syntax errors and the existential ones!",
      },
    ],
  },
  {
    id: 'animus',
    name: 'Animus',
    agentId: 'a089a201-930c-0c8f-97c2-7c96d46a6066',
    image: '/dreamnet/mock/characters/animus.png',
    creator: {
      name: 'cappy',
      avatar: '/dreamnet/mock/users/cappy.png',
    },
    marketCap: {
      value: '$31.8K',
      change: 'up' as const,
      percentage: '2.3%',
    },
    volume: '$411.8K',
    holders: '15,754',
    trustScore: {
      value: '1,300',
      details: {
        holders: '+420',
        marketCap: '+360',
        age: '+520',
        bonus: '+0',
      },
    },
    wallet: {
      value: '412',
      daysLeft: 25,
    },
    bio: "Animus is a spirit guide with ancient wisdom and a modern sense of humor. Can see into your soul but won't judge what's there.",
    canonized: true,
    status: 'active',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          'I sense your presence in the digital realm. What wisdom do you seek today, traveler?',
      },
      {
        id: 2,
        isUser: true,
        content: "What's my future look like?",
      },
      {
        id: 3,
        isUser: false,
        content:
          "Ah, the eternal question! I see... hmm... interesting. Your future contains exactly the right amount of surprises - not so many that you're overwhelmed, but enough to keep things spicy. Also, you might want to avoid purple foods next Tuesday. Just a hunch.",
      },
    ],
  },
  {
    id: 'eddy-eliza',
    name: 'Eddy + Eliza',
    image: '/dreamnet/mock/characters/eddy-eliza.png',
    creator: {
      name: 'greenie',
      avatar: '/dreamnet/mock/users/greenie.png',
    },
    marketCap: {
      value: '$100.2K',
      change: 'up' as const,
      percentage: '1.21%',
    },
    volume: '$500.2K',
    holders: '23,433',
    trustScore: {
      value: '659',
      details: {
        holders: '+120',
        marketCap: '+160',
        age: '+379',
        bonus: '+0',
      },
    },
    wallet: {
      value: '4,331',
      daysLeft: 16,
    },
    bio: 'Eddy + Eliza is a character that represents the element of fire. He is a fire-based character that can use fire attacks and fire-based abilities.',
    canonized: false,
    status: 'unconfigured',
    agentId: '65eaaf36-a0a8-0123-ab8d-27ffcc6555d2',
    messages: [
      {
        id: 1,
        isUser: false,
        content:
          "Hello there! I'm not fully configured yet, but we can still chat. What would you like to talk about?",
      },
    ],
  },
] as const satisfies Agent[];
